import _curry from 'lodash/curry';
import _castArray from 'lodash/castArray'; // Constants

import { EMPTY_ARRAY, EMPTY_OBJECT } from '../app.constants';

var getValueForId = _curry(function (byIdMap, acc, id) {
  var valueForId = byIdMap[id];

  if (valueForId) {
    acc.push(valueForId);
  }

  return acc;
});

var getValuesFromById = function getValuesFromById() {
  var byIdMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var idsList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_ARRAY;
  return _castArray(idsList).reduce(getValueForId(byIdMap), []);
}; // eslint-disable-line implicit-arrow-linebreak


export default getValuesFromById;